import React from "react";

export default (props: React.SVGAttributes<SVGElement>) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M12 2L4.5 9.5V22H19.5V9.5L12 2ZM17 19.5H13.25V15.75H10.75V19.5H7V10.5375L12 5.5375L17 10.5375V19.5ZM13.25 13.25H10.75V10.75H13.25V13.25Z" fill="black"/>
</svg>
;
